import { Button, Modal } from '@ntconsult/aluma-react';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { ItemPainel } from '../types/Painel';
import { identificacao } from './colunas';

/** "Ver selecionados": a seleção por ids inteira, inclusive quem não aparece na lista atual (spec 25 R5),
 * com a matrícula para distinguir homônimos (spec 32 R10). */
export function SelecionadosModal({
  itens,
  open,
  onClose,
  onTirar,
}: {
  itens: readonly ItemPainel[];
  open: boolean;
  onClose: () => void;
  onTirar: (id: string) => void;
}) {
  const { t } = useTranslation(['participantes', 'common']);
  return (
    <Modal open={open} onClose={onClose} ariaLabel={t('lote.selecionadosTitulo')}>
      <Modal.Header
        title={t('lote.selecionadosTitulo')}
        onClose={onClose}
        dismissLabel={t('common:close')}
      />
      <Modal.Body>
        <ul className="flex flex-col gap-2 text-sm">
          {itens.map((p) => (
            <li key={p.id} className="flex items-center justify-between gap-2">
              <span className="font-medium">{identificacao(p)}</span>
              <Button
                variant="secondary"
                size="sm"
                leftIcon={<X size={14} />}
                aria-label={t('lote.tirar', { nome: identificacao(p) })}
                onClick={() => onTirar(p.id)}
              >
                {t('lote.tirarBotao')}
              </Button>
            </li>
          ))}
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t('common:close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
